<template>
  <v-card tile class="questions-conteiner ma-0 pa-0">
    <v-row v-show="!!user.questions" justify="start" class="ma-0 pa-0">
      <v-btn @click="close" large icon class="ma-0">
        <v-icon color="#393a3a">{{ closeIcon }}</v-icon>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      justify="center"
      class="vetalfa-big-title ma-0 pa-0 mt-5"
    >
      <v-col cols="8">
        <p class="ma-0 pa-0 text-center">{{ stepTitle }}</p>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      align="start"
      class="ma-0 pa-0 mt-2"
    >
      <v-carousel
        touchless
        :cycle="false"
        hide-delimiter-background
        :show-arrows="false"
        v-model="step"
      >
        <v-carousel-item v-for="i in 3" :key="i + 'step'">
          <v-sheet color="white">
            <v-row
              align="start"
              justify="center"
              class="ma-0 pa-0"
            >
              <v-col class="ma-0 pa-0" cols="8">
                <p class="vetalfa-topic ma-0 pa-0">{{ stepTopic }}</p>
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
              class="pt-5 mt-5 ma-0 pa-0"
            >
              <v-col cols="1" class="ma-0 pa-0">
                <v-icon
                  v-if="step != 0"
                  @click="step--"
                  color="#004662"
                  class="ma-0 pa-0"
                  >{{ leftIcon }}</v-icon
                >
              </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                <v-row
                  v-show="step == 0"
                  align="center"
                  justify="center"
                  class="ma-0 pa-0"
                >
                  <v-chip
                    @click="
                      veterinaryStatus = listVeterinaryStatus.professional.id
                    "
                    label
                    class="mx-2 mt-2"
                    color="primary"
                    :outlined="
                      veterinaryStatus != listVeterinaryStatus.professional.id
                    "
                    >{{ listVeterinaryStatus.professional.description }}</v-chip
                  >
                  <v-chip
                    @click="veterinaryStatus = listVeterinaryStatus.student.id"
                    label
                    class="ma-0 mt-2"
                    color="primary"
                    :outlined="
                      veterinaryStatus != listVeterinaryStatus.student.id
                    "
                    >{{ listVeterinaryStatus.student.description }}</v-chip
                  >
                  <v-chip
                    @click="veterinaryStatus = listVeterinaryStatus.others.id"
                    label
                    class="ml-2 mt-2"
                    color="primary"
                    :outlined="
                      veterinaryStatus != listVeterinaryStatus.others.id
                    "
                    >{{ listVeterinaryStatus.others.description }}</v-chip
                  >
                </v-row>
                <v-row
                  v-show="
                    step == 1 &&
                    (veterinaryStatus == listVeterinaryStatus.student.id ||
                      veterinaryStatus == listVeterinaryStatus.professional.id)
                  "
                  class="ma-0 pa-0"
                >
                  <v-combobox
                    light
                    hide-details
                    dense
                    class="mt-4"
                    color="primary"
                    outlined
                    :items="veterinaryColleges"
                    :placeholder="labels.QUESTIONS_SCHOOL"
                    v-model="college"
                    :menu-props="{ maxHeight: 164, top: true }"
                    clearable
                  ></v-combobox>
                </v-row>
                <v-row
                  v-show="
                    step == 1 &&
                    veterinaryStatus == listVeterinaryStatus.professional.id
                  "
                  align="center"
                  justify="center"
                  class="ma-0 pa-0 pt-4"
                >
                  <v-select
                    :items="listOfAcademicDegrees"
                    item-text="description"
                    :placeholder="labels.QUESTIONS_NIVELS"
                    multiple
                    item-value="id"
                    light
                    hide-details
                    dense
                    color="primary"
                    outlined
                    :v-menu="{ offsetY: true }"
                    v-model="academicDegrees"
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index == academicDegrees.length - 1">
                        {{ item.description }}
                        <span v-if="academicDegrees.length > 1">{{
                          `(+${academicDegrees.length - 1})`
                        }}</span>
                      </span>
                    </template>
                  </v-select>
                </v-row>
                <v-row
                  v-show="
                    step == 1 &&
                    veterinaryStatus == listVeterinaryStatus.student.id
                  "
                  align="center"
                  justify="center"
                  class="ma-0 pa-0 pt-4"
                >
                  <v-select
                    :items="completionYears"
                    :placeholder="labels.QUESTIONS_GRADUATION_YEAR"
                    light
                    hide-details
                    dense
                    color="primary"
                    outlined
                    :v-menu="{ offsetY: true }"
                    v-model="courseCompletion"
                  ></v-select>
                </v-row>
                <v-row
                  v-show="
                    step == 1 &&
                    (veterinaryStatus == listVeterinaryStatus.others.id ||
                      veterinaryStatus == null)
                  "
                  align="center"
                  justify="center"
                  class="ma-0 pa-0"
                >
                  <v-text-field
                    light
                    hide-details
                    dense
                    color="primary"
                    outlined
                    :placeholder="labels.QUESTIONS_OCUPATION"
                    v-model="ocupation"
                    clearable
                  ></v-text-field>
                </v-row>
                <v-row
                  v-show="step == 2"
                  align="center"
                  justify="center"
                  class="ma-0 pa-0 px-2"
                >
                  <v-select
                    :items="areasOfInterest"
                    item-text="description"
                    :placeholder="labels.QUESTIONS_SELECT_PLACEHOLDER"
                    item-value="id"
                    light
                    multiple
                    hide-details
                    dense
                    color="primary"
                    outlined
                    v-model="interests"
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index == interests.length - 1">
                        {{ item.description }}
                        <span v-if="interests.length > 1">{{
                          `(+${interests.length - 1})`
                        }}</span>
                      </span>
                    </template>
                  </v-select>
                </v-row>
              </v-col>
              <v-col cols="1" class="ma-0 pa-0">
                <v-icon
                  @click="step++"
                  v-if="rightArrowStatus"
                  right
                  color="#004662"
                  class="ma-0 ml-4 pa-0"
                  >{{ rightIcon }}</v-icon
                >
              </v-col>
            </v-row>
            <v-row
              v-show="step == 2"
              align="center"
              justify="center"
              class="mt-5 ma-0 pa-0"
            >
              <v-btn
                color="primary"
                class="text-none"
                @click="sendQuestions()"
                >{{ labels.QUESTIONS_CONFIRM }}</v-btn
              >
            </v-row>
            <v-row
              class="pa-0 ma-0 mt-5"
              align="start"
              justify="center"
            >
              <v-icon
                x-small
                v-for="j in 3"
                :key="j + 'circle'"
                light
                color="primary"
                >{{ j == i ? circleIcon : circleOutlineIcon }}</v-icon
              >
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-row>
    <v-row></v-row>
  </v-card>
</template>

<style>
.questions-conteiner {
  background-color: white;
  height: 100%;
  max-width: 768px;
  width: 100%;
  overflow: hidden !important;
}

.questions-button {
  font-size: 16px !important;
  font-weight: normal;
}
.questions-colleges {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<script>
import {
  mdiClose,
  mdiChevronRight,
  mdiChevronLeft,
  mdiCircle,
  mdiCircleOutline,
} from "@mdi/js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import labels from "@/constants/labels.js";
import enums from "@/constants/enums.js";
export default {
  name: "Questions",
  methods: {
    ...mapActions("general", [
      "saveQuestions",
      "getVeterinaryColleges",
      "routeRedirect",
    ]),
    ...mapMutations("general", ["setConfirmModel", "setVeterinaryColleges"]),
    sendQuestions: async function () {
      this.saveQuestions({
        ocupation: this.ocupation,
        interests: this.interests,
        college: this.college,
        courseCompletion: this.courseCompletion,
        veterinaryStatus: this.veterinaryStatus,
        academicDegrees: this.academicDegrees,
      });
    },
    closeQuestions() {
      this.setVeterinaryColleges([]);
      this.routeRedirect({ name: "home" });
    },
    setCompletionYears() {
      var date = new Date();
      var baseYear = date.getFullYear();
      for (let y = 0; y < 15; y++) {
        this.completionYears.push(baseYear + y);
      }
    },
    selectCollege(selectedCollege) {
      this.college = selectedCollege;
    },
    close() {
      this.setConfirmModel({
        text: this.labels.QUESTIONS_ASK_KEEP_AWNSERING,
        confirmText: this.labels.QUESTIONS_CLOSE_SAVE,
        closeText: this.labels.QUESTIONS_KEEP_AWNSERING,
        active: true,
        callback: this.closeQuestions,
      });
    },
  },
  watch: {
    veterinaryStatus() {
      this.step++;
    },
  },
  components: {},
  computed: {
    ...mapGetters("general", ["user", "veterinaryColleges"]),
    stepTitle() {
      switch (this.step) {
        case 0:
          return labels.QUESTIONS_FIRST_STEP;
        case 1:
          return labels.QUESTIONS_SECOND_STEP;
        case 2:
          return labels.QUESTIONS_THIRD_STEP;
      }
      return "";
    },
    stepTopic() {
      switch (this.step) {
        case 0:
          return labels.QUESTIONS_FIRST_TOPIC;
        case 1:
          switch (this.veterinaryStatus) {
            case this.listVeterinaryStatus.professional.id:
              return labels.QUESTIONS_PROFESSIONAL_SECOND_TOPIC;
            case this.listVeterinaryStatus.student.id:
              return labels.QUESTIONS_STUDENT_SECOND_TOPIC;
            case this.listVeterinaryStatus.others.id:
              return labels.QUESTIONS_OTHERS_SECOND_TOPIC;
          }
        case 2:
          return labels.QUESTIONS_THIRD_TOPIC;
      }
      return "";
    },
    rightArrowStatus(){
      switch(this.step){
        case 0:
          return !!this.veterinaryStatus;
        case 1:
          return true;
        default:
          return false;
      }
    }
  },
  data() {
    return {
      step: 0,
      closeIcon: mdiClose,
      rightIcon: mdiChevronRight,
      leftIcon: mdiChevronLeft,
      circleIcon: mdiCircle,
      circleOutlineIcon: mdiCircleOutline,
      veterinaryStatus: null,
      listVeterinaryStatus: enums.VETERINARY_STATUS,
      academicDegrees: [],
      labels,
      ocupation: "",
      listOfAcademicDegrees: enums.ACADEMIC_DEGREES,
      interests: [],
      areasOfInterest: enums.AREAS_OF_INTEREST,
      college: "",
      courseCompletion: null,
      completionYears: [],
      closeModel: false,
    };
  },
  created() {
    this.setCompletionYears();
    this.getVeterinaryColleges();
  },
};
</script>